module.exports = __webpack_public_path__ + "img/pop_xinyinghu03@2x.5ac77623.png";